/**
 * Created by jerome on 29/10/2018.
 */
import Animation from '../../core/Animation'
import NSSSVGAnimator from '../../core/NSSSVGAnimator'

export default class InOutWave extends Animation {
  constructor (svgDatas, options, onUpdate, onComplete) {
    super()
    this._svgDatas = svgDatas
    this._onUpdate = onUpdate
    this._onComplete = onComplete
    this._scaleNoise = options.scaleNoise | 2
    this._force = options.force | 2
    this._wave = options.wave | 10
    this._speed = options.speed
    this._duration = options.duration | 100
    this._anchor = {
      x: this._svgDatas.bounds[0] + this._svgDatas.bounds[2] / 2,
      y: this._svgDatas.bounds[1] + this._svgDatas.bounds[3] / 2
    }
    this._forceHalf = this._force / 2
    this._noise = NSSSVGAnimator.getNoise()
  }

  update () {
    this.updateIn()
    const width = 200
    const height = 200
    let p, pMain, rx, ry, inv = 1 - this._timeRatio, t =  this._speed * this._time
    let inRatio = this._timeRatio * 5
    if (inRatio > 1) inRatio = 1
    this._svgDatas.shapes.forEach(shape => {
      shape.points.forEach(p => {
        pMain = p.main;
        [p.main, p.left, p.right].forEach(pt => {
          if (!pt) return
          rx = inRatio * inv * this._wave * (this._noise.noise2D((pt.sx / width + t) * this._scaleNoise, pt.sy / height * this._scaleNoise ));
          ry = inRatio * inv * this._wave * (this._noise.noise2D((pt.sx / width + t * .5) * this._scaleNoise, pt.sy / height * this._scaleNoise ));

          this._svgDatas.updatePoint(pt, pt.sx + rx, pt.sy + rx)
        })
      })
    })
    this.updateOut()
  }

  dispose () {
    super.dispose()
  }
}